import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Actions ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-double" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("  Verify address ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-check-circle" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  Approve ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plane-slash" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("  Cancel ship ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("  Reject order ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("  Cancel order ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-car" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-comment" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Request Seller ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-comment-dots" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Agency note ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_ctx.props.userInfo?.userType === _ctx.UserTypes.AGENCY && _ctx.validateActionWithStatus(_ctx.props.scope.row.status))
    ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              (
            _ctx.validateVerifyAddress(_ctx.props.scope.row.status) && _ctx.props.scope.row?.addressValid === _ctx.ADDRESS_STATUS.US_INVALID
          )
                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.verifyAddressOrder([_ctx.props.scope.row._id])))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _hoisted_3
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.validateApproved(_ctx.props.scope.row.status))
                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSubmitApprove([_ctx.props.scope.row._id])))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _hoisted_5
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.validateCancelShip(_ctx.props.scope.row.status))
                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: 2,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSubmitCancelShip([_ctx.props.scope.row._id])))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.validateReject(_ctx.props.scope.row.status))
                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: 3,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSubmitReject([_ctx.props.scope.row._id])))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _hoisted_9
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.validateAgencyCancel(_ctx.props.scope.row.status))
                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: 4,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onCancelReject([_ctx.props.scope.row._id])))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _hoisted_11
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (
            _ctx.props.scope.row?.fulfillmentWarning === 'not_shipping_country' || _ctx.props.scope.row.isIgnoreCannotShip != null
          )
                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: 5,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onUpdateIgnoreCannotShipOrder([_ctx.props.scope.row._id], !_ctx.props.scope.row?.isIgnoreCannotShip)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      _hoisted_13,
                      (_ctx.props.scope.row?.isIgnoreCannotShip)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Area NOT Shipping"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, "Area Can Shipping"))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_dropdown_item, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onClickRequestSeller(_ctx.props.scope.row)))
              }, {
                default: _withCtx(() => [
                  _hoisted_16,
                  _hoisted_17
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onClickAgencyNote(_ctx.props.scope.row)))
              }, {
                default: _withCtx(() => [
                  _hoisted_18,
                  _hoisted_19
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "text" }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                default: _withCtx(() => [
                  _createVNode(_component_arrow_down)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}